import { basicMapper } from '../../helpers/Mapper';
import * as status from './status';
import * as gender from './gender';
import * as vitality from './vitality';
import * as genital from './genital';
import * as breastAttachment from './breastAttachment';
import * as breastfeedingDischarge from './breastfeedingDischarge';
import * as presentation from './presentation';
import * as childbirthModality from './childbirthModality';
import * as cesareanElective from './cesareanElective';
import * as cesareanLabor from './cesareanLabor';
import * as cesareanAnesthesia from './cesareanAnesthesia';
import * as consanguinity from './consanguinity';
import * as smokeHabits from './smokeHabits';
import * as conceptionDetails from './conceptionDetails';
import * as folicAcid from './folicAcid';
import * as preBirthCourse from './preBirthCourse';
import * as mostUsedService from './mostUsedService';
import * as antibodyInvestigations from './antibodyInvestigations';
import * as courseAndAssistance from './courseAndAssistance';
import * as assistedConception from './assistedConception';
import * as childbirthPlace from './childbirthPlace';
import * as laborModality from './laborModality';
import * as analgesia from './analgesia';
import * as childbirthKind from './childbirthKind';
import * as inductionReason from './inductionReason';
import * as inductionType from './inductionType';
import * as bloodGroup from './bloodGroup';
import * as presenceBirthRoom from './presenceBirthRoom';
import * as deathInstant from './deathInstant';
import * as prePregnancyConditions from './prePregnancyConditions';
import * as prePregnancyConditionTypes from './prePregnancyConditionTypes';
import * as preLaborCesareanReasons from './preLaborCesareanReasons';
import * as inLaborCesareanReasons from './inLaborCesareanReasons';
import * as accellerations from './accellerations';
import * as maternalDiseasesInPregnancy from './maternalDiseases';
import * as maternalDiseasesTypes from './maternalDiseasesTypes';
import * as genitalMutilations from './genitalMutilations';
import * as preConceptionalVisits from './preConceptionalVisits';
import * as alcoholHabits from './alcoholics';
import * as yesNoUnknown from './yesNoUnkown';
import * as yesNo from './yesNo';
import * as professionalsFollowingPregnancy from './professionalsFollowing';
import * as pathologicalPregnancyCourses from './pathologicalCourses';
import * as nuchalTranslucency from './nuchalTranslucency';
import * as testResults from './testResults';
import * as cfDNAResults from './cfDNAResults';
import * as morphologicalResults from './morphologicalResults';
import * as invasivePrenatalTestings from './invasivePrenatalTestings';
import * as invasiveTests from './invasiveTests';
import * as severeLacerations from './severeLacerations';
import * as attendantHCPs from './attendantHCPs';
import * as laborManagement from './laborManagement';
import * as positiveTestResults from './positiveTestResults';

export const positiveTestResultsOptions = basicMapper(positiveTestResults);
export const laborManagementOptions = basicMapper(laborManagement);
export const attendantHCPOptions = basicMapper(attendantHCPs);
export const YES_NO_UNKNOWN_OPTIONS = basicMapper(yesNoUnknown);
export const YES_NO_OPTIONS = basicMapper(yesNo);
export const prePregnancyConditionOptions = basicMapper(prePregnancyConditions);
export const prePregnancyConditionTypeOptions = basicMapper(prePregnancyConditionTypes);
export const maternalDiseasesInPregnancyOptions = basicMapper(maternalDiseasesInPregnancy);
export const maternalDiseasesTypeOptions = basicMapper(maternalDiseasesTypes);
export const genitalMutilationOptions = basicMapper(genitalMutilations);
export const preConceptionalVisitOptions = basicMapper(preConceptionalVisits);
export const statusOptions = basicMapper(status);
export const genderOptions = basicMapper(gender);
export const vitalityOptions = basicMapper(vitality);
export const genitalOptions = basicMapper(genital);
export const breastAttachmentOptions = basicMapper(breastAttachment);
export const breastfeedingDischargeOptions = basicMapper(breastfeedingDischarge);
export const presentationOptions = basicMapper(presentation);
export const childbirthModalityOptions = basicMapper(childbirthModality);
export const cesareanElectiveOptions = basicMapper(cesareanElective);
export const cesareanLaborOptions = basicMapper(cesareanLabor);
export const cesareanAnesthesiaOptions = basicMapper(cesareanAnesthesia);
export const consanguinityOptions = basicMapper(consanguinity);
export const alcoholHabitsOptions = basicMapper(alcoholHabits);
export const smokeHabitsOptions = basicMapper(smokeHabits);
export const pathologicalPregnancyCoursesOptions = basicMapper(pathologicalPregnancyCourses);
export const folicAcidOptions = basicMapper(folicAcid);
export const professionalsFollowingPregnancyOptions = basicMapper(professionalsFollowingPregnancy);
export const conceptionDetailsOptions = basicMapper(conceptionDetails);
export const preBirthCourseOptions = basicMapper(preBirthCourse);
export const mostUsedServiceOptions = basicMapper(mostUsedService);
export const antibodyInvestigationsOptions = basicMapper(antibodyInvestigations);
export const courseAndAssistanceOptions = basicMapper(courseAndAssistance);
export const assistedConceptionOptions = basicMapper(assistedConception);
export const childbirthPlaceOptions = basicMapper(childbirthPlace);
export const laborModalityOptions = basicMapper(laborModality);
export const analgesiaOptions = basicMapper(analgesia);
export const childbirthKindOptions = basicMapper(childbirthKind);
export const inductionReasonOptions = basicMapper(inductionReason);
export const inductionTypeOptions = basicMapper(inductionType);
export const bloodGroupOptions = basicMapper(bloodGroup);
export const presenceBirthRoomOptions = basicMapper(presenceBirthRoom);
export const deathInstantOptions = basicMapper(deathInstant);
export const nuchalTranslucencyOptions = basicMapper(nuchalTranslucency);
export const testResultsOptions = basicMapper(testResults);
export const cfDNAResultsOptions = basicMapper(cfDNAResults);
export const morphologicalResultsOptions = basicMapper(morphologicalResults);
export const invasivePrenatalTestingsOptions = basicMapper(invasivePrenatalTestings);
export const invasiveTestsOptions = basicMapper(invasiveTests);
export const preLaborCesareanReasonOptions = basicMapper(preLaborCesareanReasons);
export const inLaborCesareanReasonOptions = basicMapper(inLaborCesareanReasons);
export const accellerationOptions = basicMapper(accellerations);
export const severeLacerationOptions = basicMapper(severeLacerations);
